import '@adornis/bh-institution/client/bh-admin-einrichtungen-list.js';
import { BuildifyLitElement } from '@adornis/html-based-buildify/client/BuildifyLitElement.js';
import { runInsertNode } from '@adornis/html-based-buildify/client/helper/runInsertNode.js';
import { MenuItemGroup, type INodeConfig } from '@adornis/html-based-buildify/client/types.js';
import { isNodeSelection } from '@adornis/html-based-buildify/client/util.js';
import type { HTMLBase } from '@adornis/html-based-buildify/db/HTMLBase.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

const INSTITUTION_LIST_KEY = 'institution-list';
export const institutionListConfig: INodeConfig = {
  node: {
    name: INSTITUTION_LIST_KEY,
    schema: {
      draggable: true,
      group: 'block',
      parseDOM: [
        {
          tag: 'bh-admin-einrichtungen-list',
        },
        {
          tag: 'node-institution-list',
        },
      ],
      toDOM: node => {
        return ['node-institution-list', { 'no-content': 'true' }];
      },
    },
  },
  menuItems: [
    {
      group: MenuItemGroup.BASIC,
      label: 'Institutionsliste',
      icon: 'list',
      run: view => runInsertNode(INSTITUTION_LIST_KEY)(view.state, view),
      shouldVisualize: view => {
        return !isNodeSelection(view.state.selection);
      },
    },
  ],
};

@customElement('node-institution-list')
export class NodeInstitutionList extends BuildifyLitElement<HTMLBase> {
  override content({ content, mode }) {
    return html` <bh-admin-einrichtungen-list></bh-admin-einrichtungen-list> `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          overflow: 'visible',
        },
      },
    ];
  }
}
